import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { openPopup} from "../../store/popupSlice" 
import Breadcrumb from '../../component/Breadcrumb';

const breadcrumbData = {
  newClass:"center-breadcrumb white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"food & grocery app",
      slug:""
    },
  ]
}

export default function FoodBanner() {
  const dispatch=useDispatch();
  return (
    <>
      <section className="custom-app-banner healthcare-banner header-gap">
        <div className="custom-banner-img">
          <img src="./assets/home/food-banner.webp" alt="banner" className='img-responsive'/>
        </div>

        <div className="custom-app-head text-center">
          <label>AI-Powered</label>
          <h1 className="heading center-heading"><span>Kick start your</span> <br />
          hyperlocal business</h1>
          <p className="sub-heading">From planning to promotion, utilize advanced food delivery app. With insights from top industry experts, we ensure a seamless journey tailored to your hyperlocal business needs.</p>
          <small>21 Days Free Trial | No Credit Card Required</small>
          <Breadcrumb breadcrumbData={breadcrumbData}/>
          <Link  onClick={() => dispatch(openPopup())}  className="default-btn animated-btn">
          get started
          </Link> 
        </div>
      </section>
    </>
  )
}
